export class ExtendedControlIcons {
  private readonly _first: string;
  private readonly _second: string;
  private readonly _third: string;
  private readonly _fourth: string;

  constructor(first: string, second: string, third: string, fourth: string) {
    this._first = first;
    this._second = second;
    this._third = third;
    this._fourth = fourth;
  }

  get first(): string {
    return this._first;
  }

  get second(): string {
    return this._second;
  }

  get third(): string {
    return this._third;
  }

  get fourth(): string {
    return this._fourth;
  }
}